import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { CrudDataService } from '../../shared/services/crud-data.service';
import { SecurityService } from '../../shared/services/security.service';
import { Configuration } from '../../app.configuration.service';
import { Logistica } from 'src/app/model/logistica/logistica';

@Injectable()
export class LogisticaDataService extends CrudDataService<Logistica> {

  constructor(protected http: HttpClient, protected configuration: Configuration, protected securityService: SecurityService) {
    super(http, configuration, securityService);
    this.controllerName = 'v1/Logistica';
  }
}
